import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Marker } from 'react-map-gl';
import { getDepotsMapObject } from '../../store/selectors/user';
import DepotMarker from '../Markers/DepotMarker';
import { useDepotAndDateChangeAction } from '../../hooks/useDepotChangeAction';
import { getSelectedDepot } from '../../store/selectors/app';

const useStyles = makeStyles({
  marker: {
    '& *': {
      // Markers not selectable
      'user-select': 'none' /* supported by Chrome and Opera */,
      '-webkit-user-select': 'none' /* Safari */,
      '-khtml-user-select': 'none' /* Konqueror HTML */,
      '-moz-user-select': 'none' /* Firefox */,
      '-ms-user-select': 'none' /* Internet Explorer/Edge */,
    },
  },
});

const DepotMapLayer = () => {
  const styles = useStyles();
  const depotsMapObject = useSelector(getDepotsMapObject);
  const selectedDepot = useSelector(getSelectedDepot);
  const { updateDepot } = useDepotAndDateChangeAction();

  return (
    <>
      {depotsMapObject &&
        depotsMapObject.map((feature) => (
          <Marker
            key={feature.properties.depot.depotCode}
            longitude={feature.geometry.coordinates[0]}
            latitude={feature.geometry.coordinates[1]}
            anchor={'bottom'}
            className={styles.marker}
            onClick={() => {
              if (feature.properties.depot.depotCode !== selectedDepot) {
                updateDepot(feature.properties.depot.depotCode);
              }
            }}
          >
            <DepotMarker
              depot={feature.properties.depot}
              isSelected={feature.properties.depot.depotCode === selectedDepot}
            />
          </Marker>
        ))}
    </>
  );
};

export default memo(DepotMapLayer);
